import React from 'react';
import { ApplicationIcon, Logo } from '@saviynt/design-system';

import { PROVIDER_NAMES } from '../../../data-layer/constants';
import { type Provider } from '../../../data-layer/types';

interface ProviderIconProps {
  provider: Provider;
  iconClassName?: string;
  logoClassName?: string;
  wrapperClassName?: string;
}

function ProviderIcon({
  provider,
  iconClassName,
  logoClassName,
  wrapperClassName,
}: ProviderIconProps) {
  if (provider.vendorName === PROVIDER_NAMES.SAVIYNT) {
    const logo = <Logo kind='SaviyntCondensed' className={logoClassName} />;

    return wrapperClassName ? (
      <div className={wrapperClassName}>{logo}</div>
    ) : (
      logo
    );
  }

  return (
    <ApplicationIcon
      logo={provider.icon}
      className={iconClassName}
      size='xxLarge'
    />
  );
}

ProviderIcon.defaultProps = {
  iconClassName: undefined,
  logoClassName: undefined,
  wrapperClassName: undefined,
};

export default ProviderIcon;
